import { FaBell, FaExclamationTriangle, FaBuilding, FaCheckCircle, FaTools, FaClock } from "react-icons/fa";

/**
 * UnifiedStatCards Component - Summary statistics cards for dashboard
 * Displays total counts, alarm severity breakdowns, and station health
 * Total Alarms = PF + FL + MF + MO
 *
 * @param {object} stats - Statistics object containing counts
 * @param {number} stats.totalAlarms - Total active alarms (PF + FL + MF + MO)
 * @param {number} stats.predictiveFailure - PF alarm count
 * @param {number} stats.failure - FL alarm count
 * @param {number} stats.maintenanceOverdue - MO count
 * @param {number} stats.maintenanceDeficiency - MF count
 * @param {number} stats.totalStations - Total number of stations
 * @param {number} stats.affectedStations - Stations with alarms
 * @param {number} stats.healthyStations - Stations without alarms
 * @param {function} onCardClick - Click handler for card clicks (type: 'total'|'pf'|'fl'|'mo'|'mf'|'affected'|'healthy')
 */
const UnifiedStatCards = ({ stats, onCardClick }) => {
  const cards = [
    {
      key: "total",
      label: "Total Alarms",
      value: stats?.totalAlarms ?? 0,
      icon: <FaBell />,
      color: "#3498db",
      bgColor: "#ebf5fb",
      clickable: true,
    },
    {
      key: "pf",
      label: "Predictive Failure",
      value: stats?.predictiveFailure ?? 0,
      icon: <FaExclamationTriangle />,
      color: "#f39c12",
      bgColor: "#fef9e7",
      clickable: true,
    },
    {
      key: "fl",
      label: "Failure",
      value: stats?.failure ?? 0,
      icon: <FaExclamationTriangle />,
      color: "#e74c3c",
      bgColor: "#fdedec",
      clickable: true,
    },
    {
      key: "mf",
      label: "Maintenance Deficiency",
      value: stats?.maintenanceDeficiency ?? 0,
      icon: <FaTools />,
      color: "#1abc9c",
      bgColor: "#e8f8f5",
      clickable: true,
    },
    {
      key: "mo",
      label: "Maintenance Overdue",
      value: stats?.maintenanceOverdue ?? 0,
      icon: <FaClock />,
      color: "#9b59b6",
      bgColor: "#f5eef8",
      clickable: true,
    },
    {
      key: "affected",
      label: "Affected Stations",
      value: stats?.affectedStations ?? 0,
      icon: <FaBuilding />,
      color: "#e67e22",
      bgColor: "#fef5e7",
      clickable: false,
    },
    {
      key: "healthy",
      label: "Healthy Stations",
      value: stats?.healthyStations ?? 0,
      icon: <FaCheckCircle />,
      color: "#27ae60",
      bgColor: "#e9f7ef",
      clickable: false,
    },
  ];

  const handleCardClick = (card) => {
    if (card.clickable && card.value > 0 && onCardClick) {
      onCardClick(card.key);
    }
  };

  return (
    <div className="unified-stat-cards">
      {cards.map((card, index) => (
        <div
          key={index}
          className={`unified-stat-card ${card.clickable && card.value > 0 ? "clickable" : ""}`}
          style={{ backgroundColor: card.bgColor, borderLeftColor: card.color }}
          onClick={() => handleCardClick(card)}
        >
          <div className="stat-icon" style={{ color: card.color }}>
            {card.icon}
          </div>
          <div className="stat-content">
            <div className="stat-value">{card.value}</div>
            <div className="stat-label">{card.label}</div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default UnifiedStatCards;
